// extracted by mini-css-extract-plugin
export default {"root":"ndhJ9i1fEskpiNa6g9iE","header":"YqO0aHBE1tSkzKlyraYS","settingsRoot":"TAUCmpd5N7bexl5CM9vv"};